import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { Section, useLanding } from '@/components/Landing/LandingKit';
import { fluid } from '@/components/Landing/landingTokens';

export function AboutSection({ label, background, children }) {
  const { c, width } = useLanding();
  return (
    <Section label={label} background={background} style={{ borderTopWidth: 1, borderTopColor: c.rule }} contentStyle={{ paddingTop: fluid(width, 44, 72), paddingBottom: fluid(width, 44, 72) }}>
      {children}
    </Section>
  );
}

export function AboutSplit({ children, style }) {
  const { isCompact } = useLanding();
  return <View style={{ flexDirection: isCompact ? 'column' : 'row', gap: isCompact ? 26 : 80, ...style }}>{children}</View>;
}

export function AboutTitle({ children, style }) {
  const { c, width } = useLanding();
  const size = fluid(width, 29, 36);
  return <Text tag="h2" weight="semibold" style={{ color: c.ink, fontSize: size, lineHeight: Math.round(size * 1.15), letterSpacing: -size * 0.035, ...style }}>{children}</Text>;
}

export function AboutBody({ children, style }) {
  const { c } = useLanding();
  return <Text tag="p" style={{ color: c.inkSoft, fontSize: 16, lineHeight: 27, ...style }}>{children}</Text>;
}
